<!-- @deprecated -->
<div *ngIf="data.showLegacyHeader" class="header">
    <a href="javascript:" class="close-button" (click)="onCloseClick()">
        <span class="close-button-label">Close</span>
        <span class="close-button-icon sp-close-icon"></span>
    </a>
</div>

<ng-container #dialogContent></ng-container>
